import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import Button from "../common-components/Button";
// import Pagination from "../common-components/Pagination";
import { faEdit, faEye, faTrash,faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
// import Loader from "../common-components/Loader";
// import { communication } from "../services/communication";
// import { getUserDetails } from "../utilities/get-user-details-from-cokies";
import Button from "../Button";
import Pagination from "../Pagination";
import { communication } from "../../services/communication";

const pageLimit = process.env.REACT_APP_LIMIT || 20;

const Complaint = () => {
  const [timeoutId, setTimeoutId] = useState();
  const [announcementList, setAnnouncementList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isPageUpdated, setIsPageUpdated] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [searchString, setSearchString] = useState("");
  const router = useNavigate();
  const [userData, setUserData] = useState({});

  //get charges on intial load
  async function getAnnouncementList(page, searchString) {
    try {
      setLoader(true);
      const responseFromServer = await communication.getAnnouncementList(page, searchString);
      if (responseFromServer?.data?.status === "SUCCESS") {
        setAnnouncementList(responseFromServer?.data?.list);
        setPageCount(responseFromServer?.data?.totalPages);
        setPage(page);
      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        router("/login");
      } else {
        setAnnouncementList([]);
        setPageCount(0);
      }
    } catch (error) {
      Swal.fire({ text: error?.response?.data?.message || error.message, icon: "warning" });
    } finally {
      setLoader(false);
    }
  }

  const deleteAnnouncemnet = async (id, event) => {
    try {
      event.stopPropagation();

      const confirmation = await Swal.fire({
        text: "Do you really want to delete this announcement?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      });

      if (confirmation.isConfirmed) {
        setLoader(true);
        const responseFromServer = await communication.deleteAnnouncemnet(id);

        if (responseFromServer?.data?.status === "SUCCESS") {
          Swal.fire({ text: responseFromServer?.data?.message, icon: "success" })
          await getAnnouncementList(currentPage, searchString);

        } else if (responseFromServer?.data?.status === "JWT_INVALID") {
          Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
          router("/login");
        } else {
          setAnnouncementList([]);
          setPageCount(0);
        }
      }
    } catch (error) {
      Swal.fire({ text: error?.response?.data?.message || error.message, icon: "warning" });
    } finally {
      setLoader(false);
    }
  };


  console.log(" announcementListannouncementListannouncementList : ", announcementList)
  useEffect(() => {
    getAnnouncementList(currentPage, searchString);
  }, [isPageUpdated]);
  return (
    <>
      <div className="actionbar_main_wrraper">

        <div className="other_action">
          <div className="other_action_wrraper">
            {/* <Pagination
              isPageUpdated={isPageUpdated}
              setIsPageUpdated={setIsPageUpdated}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pageCount={pageCount}
            /> */}
          </div>

        </div>
        <div className="search_wrraper d-flex flex-end">
          <div className="search_main ">
            <button
              className="btn btn-danger search_btn"
              onClick={() => router(`/main-panel/complaint/add-complaint`)}
            >
              {" "}
              Create
            </button>

          </div>
        </div>
      </div>

      <div className="table_wrapper">
        <div className="table_main">
          {/* Rename the class name "user-management_table" to your desired class name and specify its width in pixels. Adjust the width according to each column if needed. */}
          <div className="table_section user-management_table">
            <div className="table_header">
              <div className="col_7p">
                <h5>Sr. No.</h5>
              </div>
              <div className="col_10p">
                <h5>Title</h5>
              </div>
              <div className="col_30p">
                <h5>Description</h5>
              </div>
              <div className="col_10p">
                <h5>Created By</h5>
              </div>
              <div className="col_10p">
                <h5>Position</h5>
              </div>

              <div className="col_10p">
                <h5>Created At</h5>
              </div>
              <div className="col_7p">
                <h5>Action</h5>
              </div>
            </div>
            {announcementList?.length > 0 ?
              <>
                {
                  announcementList?.map((item, index) => (
                    <div className="table_data" key={item._id} >
                      <div className="col_7p"><h6>{index + 1}</h6></div>
                      <div className="col_10p"><h6>{item?.title}</h6></div>
                      <div className="col_30p">
                        <h6>{item?.description?.substr(0, 50)}</h6>
                        {item?.description?.length >= 50 && <h6 className="read_more_icon" style={{ background: (index % 2 === 0) ? "#E1E4F6" : "#FFFFFF" }} onClick={() => Swal.fire({ className: "read_more_modal", title: 'Description', confirmButtonText: 'Close', text: `${item?.description}` })}>{item?.description?.length > 50 && "Read More..."}</h6>}
                      </div>
                      <div className="col_10p"><h6>{item?.createdBy}</h6></div>
                      <div className="col_10p"><h6>{item?.position}</h6></div>
                      <div className="col_10p"><h6>{item?.createdAt?.split("T")[0]}</h6></div>
                      <div className="col_7p">
                        <h6 className='action_wrraper'>
                          <FontAwesomeIcon
                            icon={faPenToSquare}
                            className="cursor_pointer"
                            onClick={() => router(`/main-panel/complaint/update-complaint?id=${item?._id}`)}
                            title="Update Annoucement"
                          />
                          <FontAwesomeIcon
                            icon={faTrash}
                            className="cursor_pointer"
                            onClick={(event) => {
                              deleteAnnouncemnet(item?._id, event)
                            }}
                            title="Delete Annoucement"
                          />

                        </h6>
                      </div>
                    </div>
                  ))
                }
              </>
              :
              <div className="data_not_available">
                <h6>Data Not Available</h6>
              </div>}


          </div>
        </div>
      </div>
    </>
  );
};

export default Complaint;
